import { ShieldCheck, GitCompare, Share2, FileCheck2 } from "lucide-react";
import { Reveal, MaskLines } from "./motion";
import { GALLERIES } from "../../lib/assets";
import { GlassCard, DeviceMock } from "./Glass";

const rows = [
  { icon: FileCheck2, label: "Certifica en blockchain" },
  { icon: ShieldCheck, label: "Valida autenticidad" },
  { icon: GitCompare, label: "Compara versiones" },
  { icon: Share2, label: "Comparte accesos" },
];

export const Conservatorio = () => {
  return (
    <section
      id="conservatorio"
      data-testid="conservatorio-section"
      className="relative flex min-h-screen items-center overflow-hidden bg-canvas px-6 pb-24 pt-28 text-ink md:px-12"
    >
      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-12 lg:grid-cols-2">
        <div>
          <h2 className="font-display text-4xl font-light leading-[0.95] tracking-tight text-ink md:text-6xl">
            <MaskLines lines={["Tu repositorio", "privado, certificado", "en la cadena."]} />
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-md font-body text-base leading-relaxed text-ink-soft md:text-lg">
              Sube, organiza y certifica documentos sobre la Fragoso Smart
              Chain. Consúltalos, actualízalos, compáralos, comparte accesos y
              valida su autenticidad — todo con respaldo verificable.
            </p>
          </Reveal>

          <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {rows.map((r, i) => (
              <GlassCard
                key={r.label}
                delay={0.08 * i}
                className="flex items-center gap-3 p-5"
              >
                <r.icon className="h-5 w-5 shrink-0 text-gold" strokeWidth={1.5} />
                <span className="font-accent text-sm text-ink">{r.label}</span>
              </GlassCard>
            ))}
          </div>
        </div>

        <GlassCard testId="conservatorio-device" delay={0.15} className="p-8 md:p-10">
          <DeviceMock
            src={GALLERIES.conservatorio[0].src}
            alt={GALLERIES.conservatorio[0].alt}
            className="min-h-[440px]"
            imgClassName="max-h-[540px]"
          />
        </GlassCard>
      </div>
    </section>
  );
};
